import { render, staticRenderFns } from "./ExpedienteitemQuicktable.vue?vue&type=template&id=5257b6c2&"
import script from "./ExpedienteitemQuicktable.vue?vue&type=script&lang=js&"
export * from "./ExpedienteitemQuicktable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports